module.exports = __webpack_public_path__ + "media/images/pic/sausages-d6dea2b17c53ff402179e9eefc0543f1.jpg";